import Vue from 'vue'
import Vuex from 'vuex'
import filterTypes from "@/constants/filterTypes";
import router from '../router'
import axios from 'axios'
import {objectSort} from "@/utils/objectSort";

Vue.use(Vuex);

/*const objectTypes = {
    house: 'house',
    apartment: 'apartment',
    land: 'land',
}*/

const objectSortFiled = {
    price: (obj) => obj.price?.current.RUR,
    area: (obj) => obj.area,
    new: (obj) => obj.new,
}


const store = new Vuex.Store({
    state: {
        filters: {
            type: [],
            currency: ['RUR'],
            village: [],
            complex: [],
            tp: [1, 2, 3]
        },
        globalFilter: null,
        sort: {
            type: 'new',
            rise: true,
        },
        objects: [],
        broker: {},
        cabinet: {},//{title: "Личный кабинет", all: 3, shown: 0, likes: 0, dislikes: 0}
        village: {
            title: 'Коттеджный поселок',
            list: []
        },
        complex: {
            title: 'ЖК',
            list: []
        },
        type: {
            title: 'Тип объекта',
            list: [/*{
                title: 'Квартира',
                value: 'town_flats',
            }*/]
        },
        tp: {
            title: '',
            list: [
                {
                    title: 'Первичная',
                    value: 1,
                },
                {
                    title: 'Вторичная',
                    value: 2,
                },
                {
                    title: 'Аренда',
                    value: 3,
                }
                ]
        },
        group: []
    },
    actions: {
        fetchObjects({state}){
            let params = router.currentRoute.params;
            let url = '/api.php?action=object_list&user_id='+params.user_id+'&link='+params.link;

            console.log(router.currentRoute.params)

            return API(url).then((data)=>{
                state.objects = data;

                state.objects.filter(object => {

                    if (object.type === 'country_houses') {

                        // фильтр по типу объекта
                        let obj = {
                            title: 'Дом',
                            value: object.type,
                        };

                        if (!containsObject(obj, state.type.list)) {
                            state.type.list.push(obj);
                        }

                        state.filters.type.push( object.type);

                        //console.log(state.filters.type);

                        // фильтр по типу КП
                        let village = {
                            title: object.location_name,
                            value: object.village,
                        };

                        if (!containsObject(village, state.village.list)) {
                            state.village.list.push(village);
                        }

                        state.filters.village.push(object.village);
                        //console.log(state.filters.village);


                        // группировка по КП
                        let v = {
                            title: object.location_name,
                            value: object.village,
                            objects: []
                        };

                        if (!containsObject(v, state.group)) {
                            state.group.push(v);
                        }
                    }

                    if (object.type === 'country_lands') {

                        // фильтр по типу объекта
                        let obj = {
                            title: 'Участок',
                            value: object.type,
                        };

                        if (!containsObject(obj, state.type.list)) {
                            state.type.list.push(obj);
                        }

                        state.filters.type.push( object.type);

                        // фильтр по типу КП
                        let village = {
                            title: object.location_name,
                            value: object.village,
                        };

                        if (!containsObject(village, state.village.list)) {
                            state.village.list.push(village);
                        }

                        state.filters.village.push(object.village);


                        // группировка по КП
                        let v = {
                            title: object.location_name,
                            value: object.village,
                            objects: []
                        };

                        if (!containsObject(v, state.group)) {
                            state.group.push(v);
                        }

                    }

                    if (object.type === 'town_flats') {

                        // фильтр по типу объекта
                        let obj = {
                            title: 'Квартира',
                            value: object.type,
                        };

                        if (!containsObject(obj, state.type.list)) {
                            state.type.list.push(obj);
                        }

                        state.filters.type.push( object.type);

                        // фильтр по типу ЖК
                        let complex = {
                            title: object.location_name,
                            value: object.village,
                        };

                        if (!containsObject(complex, state.complex.list)) {
                            state.complex.list.push(complex);
                        }

                        state.filters.complex.push(object.village);

                        // группировка по ЖК
                        let v = {
                            title: object.location_name,
                            value: object.village,
                            objects: []
                        };

                        if (!containsObject(v, state.group)) {
                            state.group.push(v);
                        }

                    }
                });
            });
        },
        getBrokerData({state}) {
            let params = router.currentRoute.params;
            let url = '/api.php?action=broker_data&user_id='+params.user_id;

            return API(url).then((data)=>{
                state.broker = data;
            });
        },
        getCabinetData({state}) {
            let params = router.currentRoute.params;
            let url = '/api.php?action=cabinet_data&link='+params.link;

            return API(url).then((data)=>{
                state.cabinet = data;
            });
        }
    },
    mutations: {
        setBlockViewModeStatus(s, status) {
            s.blockView = status;
        },
        setObjectLikeStatus(s, {id, status}) {
            const object = s.objects.find(object => object.id === id);
            if (object) {
                object.likeStatus = status;

                let params = router.currentRoute.params;

                let data = axios.get('/api.php?action=set_like_status&object_id='+id+'&status='+status+'&link='+params.link+'&user_id='+params.user_id);

                s.cabinet.likes = s.cabinet.dislikes = 0;

                s.objects.filter(object => {
                        if(object.likeStatus === 1) {
                            s.cabinet.likes += 1;
                        }
                        if(object.likeStatus === -1) {
                            s.cabinet.dislikes += 1;
                        }
                    });


                console.log(data);
                console.log(s.cabinet.likes);

                /*if(data.status === 'success'){
                    console.log(data);
                } else {
                    throw new Error(data.status);
                }*/
                //setLike(id, status);
            }
        },
        setFilters(s, {filters, type}) {
            //console.log(s.filters[type])
            s.filters[type] = filters;
        },
        setSort(s, {type, rise}) {
            s.sort.type = type;
            s.sort.rise = rise;
        },
        setGlobalFilter(s, filter) {
            s.globalFilter = filter;
        }
    },
    methods: {

    },
    getters: {
        currency(s){
            //console.log(s.filters);
            return s.filters.currency[0] || 'RUR';
        },
        getObjectById: s => id => {
            return s.objects.find(object => object.id == id);
        },
        filteredAndSortingObjects(s) {
            // implemented only global filters
            let filteredObjects = [...s.objects];
            if(s.globalFilter !== null) {
                filteredObjects = filteredObjects
                    .filter(object => {
                        if(s.globalFilter === filterTypes.liked) {
                            return object.likeStatus === 1;
                        }
                        if(s.globalFilter === filterTypes.disliked) {
                            return object.likeStatus === -1;
                        }
                        if(s.globalFilter === filterTypes.shown) {
                            return object.shown;
                        }
                        return true
                    });
            }
            filteredObjects = filteredObjects.filter((obj)=>isValidObj(obj, s.filters));
            //console.log(filteredObjects);
            return [...filteredObjects].sort(objectSort(objectSortFiled[s.sort.type], !s.sort.rise));
        },
        getGrouped(s) {

            // implemented only global filters
            let filteredObjects = [...s.objects];
            if(s.globalFilter !== null) {
                filteredObjects = filteredObjects
                    .filter(object => {
                        if(s.globalFilter === filterTypes.liked) {
                            return object.likeStatus === 1;
                        }
                        if(s.globalFilter === filterTypes.disliked) {
                            return object.likeStatus === -1;
                        }
                        if(s.globalFilter === filterTypes.shown) {
                            return object.shown;
                        }
                        return true
                    });
            }
            filteredObjects = filteredObjects.filter((obj)=>isValidObj(obj, s.filters));

            let items = [...filteredObjects].sort(objectSort(objectSortFiled[s.sort.type], !s.sort.rise));

            s.group.forEach(function(v) {
                v.objects = items.filter((item) => item.village === v.value)
            });

            let arr = s.group.filter((group) => group.objects.length );

            return arr;
        }
    }
});

function isValidObj(obj, filters){
    //console.log(filters);

    if((filters.village?.length || filters.complex?.length || filters.tp?.length) && filters.type?.length) {
        return (filters.village.includes(obj.village) || filters.complex.includes(obj.village)) && filters.tp.includes(obj.tp) && filters.type.includes(obj.type);
    }

    if(filters.village?.length || filters.complex?.length || filters.tp?.length) {
        return filters.village.includes(obj.village) || filters.complex.includes(obj.village) && filters.tp.includes(obj.tp);
    }

    if(filters.type?.length) {
        return filters.type.includes(obj.type);
    }

    return true;
}

function API(url) {
    //console.log(route.params);
    //const BASE_URL = '/'
    /*const headers = { "Content-Type": "application/json", mode: 'no-cors' };
    return fetch(url, { headers }).then(function (res){*/

    return fetch(url).then(function (res){
        //console.log(url);
        if(res.status !== 200) {
            return res.text().then((err) => {
                //console.warn(res, err);
                throw new Error(`HTTP #${res.status}} ${err}`);
            });
        }
        else {
            return res.json();
        }
    });
}

function containsObject(obj, list) {
    let x;
    for (x in list) {
        //console.log(list[x], obj);
        if (list[x].value === obj.value) {
            return true;
        }
    }

    return false;
}

export default store;

